import React, { push, Component } from "react";
import {
  Grommet,
  Box,
  Header,
  Button,
  Layer,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  Card,
  CardHeader,
  CardBody,
  List,
  Grid,
  TextInput,
  Select,
  RadioButtonGroup,
  Form,
  CheckBox,
  DateInput,
  FormField,
  CheckBoxGroup,
  Tabs,
  Tab,
  Image,
  CardFooter,
  IFrame,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Notification,
  Console,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  CaretDownFill,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Filter,
  Video,
  DocumentPdf,
  Inspect,
  Close,
} from "grommet-icons";
import { hpe as theme } from "grommet-theme-hpe";

class GetHelpL2 extends Component {
  // const { push } = React.useContext(RouterContext);

  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  render() {
    return (
      <Layer
        full={true}
        position="center"
        height="medium"
        onClickOutside={this.props.hide}
        onEsc={this.props.hide}
      >
        <Box fill="vertical" align="stretch" justify="start">
          <Main
            overflow="auto"
            background={{ image: "url('')" }}
            flex
            align="stretch"
            justify="start"
          >
            <Box
              align="stretch"
              justify="center"
              flex="grow"
              background={{ color: "background-back" }}
              direction="row"
            >
              <Box
                align="stretch"
                justify="start"
                flex="shrink"
                pad={{ horizontal: "large", vertical: "medium" }}
                basis="xlarge"
                direction="column"
                gap="medium"
              >
                <Box align="center" justify="end" direction="row">
                  <Button
                    icon={<Close />}
                    onClick={this.props.hide}
                    secondary
                  />
                </Box>
                <Header
                  align="start"
                  direction="column"
                  flex={false}
                  justify="start"
                  gap="xxsmall"
                >
                  {/* <Button
                    label="Back"
                    icon={<FormPrevious />}
                    onClick={() => push("/gethelp-live")}
                  /> */}
                  <Heading margin="none">
                    Get Help - Cannot start Citrix remote desktop
                  </Heading>
                </Header>
                <Box
                  align="stretch"
                  justify="center"
                  pad="medium"
                  gap="large"
                  direction="column"
                >
                  <Card hoverIndicator>
                    <CardHeader
                      align="start"
                      direction="column"
                      justify="start"
                    >
                      <Box align="center" justify="center" direction="row">
                        <Heading size="small" level="4">
                          The Issue:
                        </Heading>
                      </Box>
                      <Grid
                        columns={{ size: "small", count: "fit" }}
                        rows="small"
                        fill="horizontal"
                      >
                        <Paragraph size="medium">
                          Error when opening Citrix remote desktop
                        </Paragraph>
                        <Image
                          src="/img/GetHelp/GHL2-vmlaunch.png
"
                          fit="contain"
                        />
                      </Grid>
                    </CardHeader>
                    <CardBody
                      direction="column"
                      justify="start"
                      align="stretch"
                    >
                      <Heading size="small" level="4">
                        The Resolution:
                      </Heading>
                      <Paragraph size="medium" textAlign="start" fill>
                        2 possibilities : either you used the Citrix light
                        version or the locally installed Citrix Receiver plugin:
                      </Paragraph>
                      <Paragraph size="medium" textAlign="start" fill>
                        When using Citrix light version : connection issues may
                        appear depending on your corporate IT security rules. In
                        that case, please choose option "DETECT RECEIVER" and
                        install Citrix Receiver Plugin on your laptop (to be
                        done only once).
                      </Paragraph>
                      <Paragraph size="medium" textAlign="start" fill>
                        When using Citrix Receiver Plugin : connection issues
                        may appear if you plugin is too old or badly installed.
                        In that case, either uninstall and reinstall Citrix
                        Receiver plugin OR choose option "Use light version" to
                        access via HTML5.
                      </Paragraph>
                      <Image
                        src="/img/GetHelp/GHL2-CitrixReceiver.png
"
                        fit="contain"
                      />
                      <Paragraph size="medium" fill>
                        "Use light version" is opening an HTML5 browser window.
                        No need to install Citrix receiver plugin on your laptop
                      </Paragraph>
                      <Text weight="bold">
                        Uninstall Citrix Receiver Plugin:
                      </Text>
                      <Text>1. Open up uninstall program on windows</Text>
                      <Text>2. search for Citrix Receiver and uninstall</Text>
                      <Text>3. Run the cleanup tool located here:</Text>
                      <Anchor
                        label="Citrix removal tool"
                        href="https://drive.google.com/file/d/1DXPoXFIVXFpuzjSrcnHBUk6GzkdmAwz2/view?usp=sharing"
                      />
                      <Text>
                        4. Launch again your demo and choose option "DETECT
                        RECEIVER" to install Citrix Receiver Plugin.
                      </Text>
                    </CardBody>
                    <CardFooter
                      align="center"
                      direction="row"
                      flex={false}
                      justify="between"
                      gap="medium"
                      pad="small"
                    >
                      <Text size="xsmall">#GH-L2</Text>
                    </CardFooter>
                  </Card>
                </Box>
              </Box>
            </Box>
          </Main>
        </Box>
      </Layer>
    );
  }
}

export default GetHelpL2;
